const initialState = {

    //operation Expense list
    loadingOperationExpenseList: false,
    OperationExpenseList: [],
    OperationExpenseListError: '',
    OperationExpenseListCurrentPage: 0,
    OperationExpenseListTotalPage: 0,
    OperationExpenseListTotalData: 0,
    OperationExpenseListJobOrderNumber: "",
    OperationExpenseListJobOrderLocked: false,
    OperationExpenseListJobOrderID: 0,
    OperationExpenseListQuotationNumber: "",
    OperationExpenseListHasQuotationNumber: false,



    //opertaion Expense remark list
    loadingOperationExpenseRemarkList: true,
    OperationExpenseRemarkList: [],
    OperationExpenseRemarkListError: "",

    //operation expense detail
    loadingOperationExpenseDetail: true,
    OperationExpenseDetail: [],
    OperationExpenseDetailError: "",

}

const OperationExpenseReducer = (state = initialState, action) => {
    switch (action.type) {

        //list operation expense//
        case 'FIND_OPERATION_EXPENSE_LIST_REQUEST':
            return {
                ...state,
                loadingOperationExpenseList: true,
                OperationExpenseList: [],
                OperationExpenseListError: "",
                OperationExpenseListCurrentPage: 1,
                OperationExpenseListTotalPage: 1,
                OperationExpenseListTotalData: 0,
                OperationExpenseListJobOrderNumber: "",
                OperationExpenseListJobOrderLocked: false,
                OperationExpenseListJobOrderID: 0,
                OperationExpenseListQuotationNumber: "",
                OperationExpenseListHasQuotationNumber:false,
            };
        case 'FIND_OPERATION_EXPENSE_LIST_SUCCESS':
            return {
                ...state,
                loadingOperationExpenseList: false,
                OperationExpenseList: action.payload.data,
                OperationExpenseListError: "",
                OperationExpenseListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                OperationExpenseListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 1,
                OperationExpenseListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                OperationExpenseListJobOrderNumber: action.payload.job_order_number,
                OperationExpenseListJobOrderLocked: action.payload.is_job_order_locked,
                OperationExpenseListJobOrderID: action.payload.job_order_id,
                OperationExpenseListQuotationNumber: action.payload.quotation_number,
                OperationExpenseListHasQuotationNumber:action.payload.has_quotation,

            };
        case 'FIND_OPERATION_EXPENSE_LIST_FAILURE':
            return {
                ...state,
                loadingOperationExpenseList: false,
                OperationExpenseList: [],
                OperationExpenseListError: action.payload,
                OperationExpenseListCurrentPage: 1,
                OperationExpenseListTotalPage: 1,
                OperationExpenseListTotalData: 0,
                OperationExpenseListJobOrderNumber: "",
                OperationExpenseListJobOrderLocked: false,
                OperationExpenseListJobOrderID: 0,
                OperationExpenseListQuotationNumber: "",
                OperationExpenseListHasQuotationNumber:false,

            };
        //list operation expense//

        //list operation expense remarks//
        case 'FIND_OPERATION_EXPENSE_REMARKS_LIST_REQUEST':
            return {
                ...state,
                loadingOperationExpenseRemarkList: true,
                OperationExpenseRemarkList: [],
                OperationExpenseRemarkListError: "",
            };
        case 'FIND_OPERATION_EXPENSE_REMARKS_LIST_SUCCESS':
            return {
                ...state,
                loadingOperationExpenseRemarkList: false,
                OperationExpenseRemarkList: action.payload,
                OperationExpenseRemarkListError: "",
            };
        case 'FIND_OPERATION_EXPENSE_REMARKS_LIST_FAILURE':
            return {
                ...state,
                loadingOperationExpenseRemarkList: false,
                OperationExpenseRemarkList: [],
                OperationExpenseRemarkListError: action.payload,
            };
        //list operation expense remarks//

        //operation expense details//
        case 'FIND_OPERATION_EXPENSE_DETAIL_REQUEST':
            return {
                ...state,
                loadingOperationExpenseDetail: true,
                OperationExpenseDetail: {},
                OperationExpenseDetailError: "",
            };
        case 'FIND_OPERATION_EXPENSE_DETAIL_SUCCESS':
            return {
                ...state,
                loadingOperationExpenseDetail: false,
                OperationExpenseDetail: action.payload,
                OperationExpenseDetailError: "",
            };
        case 'FIND_OPERATION_EXPENSE_DETAIL_FAILURE':
            return {
                ...state,
                loadingOperationExpenseDetail: false,
                OperationExpenseDetail: {},
                OperationExpenseDetailError: action.payload,
            };
        //operation expense details//

        default:
            return state;
    }
}

export default OperationExpenseReducer;